import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const UserRoute = ({ component: Component }) => {
  const { auth } = useAuth();

  return auth.token && auth.role === 'user' ? <Component /> : <Navigate to="/login" />;
};

export default UserRoute;
